import React from 'react';
import { Switch } from 'react-router-dom';
import PropTypes from 'prop-types';
import { PrivateRoute } from '../components';
import BestigeFeatures from './features/BestigeFeatures';
import AqeFeatures from './features/AqeFeatures';


const propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string.isRequired,
  }).isRequired,
};

function FeatureRouter({ match }) {
  return (
    <Switch>
      <PrivateRoute exact path={`${match.path}/bestige`} component={BestigeFeatures} />
      <PrivateRoute exact path={`${match.path}/aqe`} component={AqeFeatures} />
    </Switch>
  );
}

FeatureRouter.propTypes = propTypes;
export default FeatureRouter;
